import api from './axiosInstance';
import { API_BASE_URL } from '../config';

const MY_DATA_URL = `${API_BASE_URL}/MyData`;

export const getUserById = async (id) => {
  try {
    const response = await api.get(`${MY_DATA_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

// export const updateUserData = async (id, userData) => {
//   try {
//     const dataToSend = {
//       name: userData.name,
//       email: userData.email,
//       phone: userData.phone,
//       position: userData.position,
//       password: userData.currentPassword,
//       passwordNew: userData.newPassword,
//     };

//     const response = await api.put(`${MY_DATA_URL}/${id}`, dataToSend);
//     return response.data;
//   } catch (error) {
//     console.error('Error updating user data:', error);
//     const backendMessage = error.response?.data?.message;
//     throw new Error(backendMessage || 'Error al actualizar los datos');
//   }
// };

export const updateUserData = async (id, formData) => {
  try {
    const response = await api.put(`${MY_DATA_URL}/${id}`, formData);

    return response.data;
  } catch (error) {
    console.error('Error updating user data:', error);

    // Backend puede devolver errores por campo (ModelState)
    if (error.response?.data) {
      throw error.response.data;
    }

    throw new Error('Error al actualizar los datos');
  }
};
